<template>
    <div class="card border-1 mb-1 section-card">
        <div class="section-header">
            <div class="d-flex align-items-center">
                <span class="section-title">{{ title }}</span>
                <span class="row-count-badge">{{ rows.length }}</span>
            </div>
            <span class="section-total">{{ commaFormat(total) }}</span>
        </div>

        <p v-if="!rows.length" class="text-center my-2 mb-1">No items added in this section.</p>

        <div v-if="rows.length" class="table-responsive">
            <table class="table custom-table-padding mb-0 section-table">
                <thead>
                    <tr>
                        <th>Item</th>
                        <th class="text-right">Quantity</th>
                        <th class="text-right">Wastage</th>
                        <th class="text-right">Total Qty</th>
                        <th class="text-right">Rate</th>
                        <th class="text-right">Amount</th>
                        <th>UOM</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="general in rows" :key="general.id">
                        <td>{{ itemName(general) }}</td>
                        <td class="text-right">{{ general.quantity }}</td>
                        <td class="text-right">{{ general.wastage }}</td>
                        <td class="text-right">{{ general.total_quantity }}</td>
                        <td class="text-right">{{ commaFormat(general.rate) }}</td>
                        <td class="text-right">{{ commaFormat(general.amount) }}</td>
                        <td>{{ general.unit_of_measurment }}</td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr class="bg-light-success">
                        <th colspan="5" class="text-right">Section Total</th>
                        <th class="text-right">{{ commaFormat(total) }}</th>
                        <th></th>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
</template>

<script setup>
import figureFormatter from '@/services/utils/figureFormatter'

defineProps({
    title: { type: String, required: true },
    rows: { type: Array, required: true },
    total: { type: [Number, String], default: 0 }
})

const { commaFormat } = figureFormatter()

const itemName = (general) => {
    if (!general.product_costingable) return ''
    return general.product_costingable.name
}
</script>

<style scoped>
.section-card {
    overflow: hidden;
}
.section-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 14px;
    background-color: rgba(115, 103, 240, 0.08);
    border-bottom: 1px solid rgba(115, 103, 240, 0.16);
}
.section-title {
    font-size: 14px;
    font-weight: 600;
}
.row-count-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 20px;
    height: 20px;
    padding: 0 6px;
    margin-left: 8px;
    border-radius: 10px;
    background-color: rgba(115, 103, 240, 0.18);
    font-size: 11px;
    font-weight: 600;
}
.section-total {
    font-size: 14px;
    font-weight: 700;
}
.section-table thead th {
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.02em;
}
.section-table tbody tr:nth-child(even) {
    background-color: rgba(0, 0, 0, 0.02);
}
</style>
